export const RESOLUTION_ZOOMLEVEL_ZERO = 512;
